/*
Wire Pulls
  --length <float> | inches
*/
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'
import { length } from '@/modules/standardItems/schemas/baseFormFields'

export default [
  ...hardwareFormFields,
  length({ classes: ['xs12', 'sm4'] })
]
